import { NgModule } from '@angular/core';
import { HighchartsChartComponent } from './highcharts-chart.component';

@NgModule({
  declarations: [HighchartsChartComponent],
  exports: [HighchartsChartComponent]
})
export class HighchartsChartModule {}
